import classname from 'classname';
import Badge from 'components/Badge';
import Drawer from 'components/drawer';
import { formatWithCommas, statusTextColorMapping } from 'libs';
import { camelCase, isArray } from 'lodash';
import moment from 'moment';
import React from 'react';
import { globalStyles } from 'styles';
import styles from './transaction.module.scss';

export default function Transactiondetails({
  txtRow,
  drawerActive,
  setDrawerActive,
}) {

  return (
    <Drawer
      title="Transaction details"
      setDrawerActive={setDrawerActive}
      drawerActive={drawerActive}
    >
      <Drawer.DrawerBody>
        <div className={classname(styles.trasactionDetail, globalStyles.pt0)}>
          <p>Amount</p>
          <p>₦{formatWithCommas(txtRow.amount)}</p>
        </div>
        <div className={styles.trasactionDetail}>
          <p>Transaction ref</p>
          <p>{txtRow.parentReference ? `${txtRow.parentReference}` : '-'}</p>
        </div>
        <div className={styles.trasactionDetail}>
          <p>Date/Time</p>
          <p>
            {txtRow.createdAt &&
              moment(txtRow.createdAt).format('MMM D, YYYY LT')}
          </p>
        </div>
        <div className={styles.trasactionDetail}>
          <p>Status</p>
          <div>
            <Badge color={statusTextColorMapping[txtRow.status]?.color}>
              {statusTextColorMapping[txtRow.status]?.text}
            </Badge>
          </div>
        </div>
        {txtRow?.meta && (
          <>
            <div className={styles.trasactionDetailTitle}>Other Details</div>

            {Object.keys(txtRow.meta).map((key) => (
              <div className={classname(styles.trasactionDetail)} key={key}>
                <p>{key.replaceAll('_', ' ')}</p>
                <p
                  className={classname(key.includes('_id') ? styles.noCap : '')}
                >
                  {txtRow.meta[key] &&
                    (isArray(txtRow[key])
                      ? txtRow.meta[key].toString()
                      : txtRow.meta[key]
                          .replaceAll(']', '')
                          .replaceAll('[', ''))}
                </p>
              </div>
            ))}
          </>
        )}
      </Drawer.DrawerBody>
    </Drawer>
  );
}
